import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NewsEntity, NewsList } from '@core/entities/news.entity';
import { FilterQuery } from '@core/types';
import { map } from 'rxjs/operators';
import { GetUserId } from '@core/utils';

@Injectable({
  providedIn: 'root',
})
export class GroupNewsService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;
  private readonly _userId = GetUserId();

  find(groupId: number, queryParams?: FilterQuery): Observable<NewsList> {
    return this._http.get<any>(`${this._apiUrl}/groupNews/groupId/${groupId}`, { params: queryParams }).pipe(
      map((response) => {
        return {
          pagination: response.pagination,
          news: response.groupNews,
        } as NewsList;
      }),
    );
  }

  get(newsId: number): Observable<NewsEntity> {
    return this._http.get<any>(`${this._apiUrl}/get-news-by-id/${newsId}`).pipe(map((response) => response.result));
  }

  delete(newsId: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/news/${newsId}/user/${this._userId}`);
  }
}
